<template>
    <modal :show.sync=show modalClasses="medium-sized-modal" :hide-footer="true">
        <h3 slot="header" class="mb-0 font-weight-500">Create New Channel</h3>

        <ValidationObserver v-slot="{ invalid }" ref="observer">
                <b-form @submit.prevent="submit" ref="newChannelForm">
                    <b-row>
                        <!-- FIELD CHANNEL NAME -->
                        <b-col cols="12" md="12">
                            <b-form-group label="Channel:">
                                <ValidationProvider
                                    v-slot="{ errors }"
                                    :rules="{ required: true }"
                                    :vid="'newChannelName'"
                                >
                                <b-form-input
                                    v-model="new_channel.channel_name"
                                    type="text"
                                    required
                                    ></b-form-input>
                                    <small v-if="errors[0]" class="text-danger">{{ errors[0] }}</small>
                                </ValidationProvider>
                            </b-form-group>
                        </b-col>
                        <b-col md="6" sm="12" class="mx-auto text-center mt-4 pt-2">
                            <b-button variant="primary" type="submit" class="w-100" :disabled="invalid">Create</b-button>
                        </b-col>
                    </b-row>
                </b-form>
            </ValidationObserver>

    </modal>
</template>
<script>
import Modal from "@/components/Modal"
import { Select, Option } from 'element-ui'
import { 
  notifyFunctionMixin,
  helperFunctionMixin,
  axios,
  services,
  getHeader
} from '@/assets/js/httpImports.js'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import '@/assets/js/formValidations.js'
import { EventBus } from "@/main"

export default {
    props:{
        create_channel: Boolean,
        hubList: Array,
    },
    mixins:[
        notifyFunctionMixin,
        helperFunctionMixin
    ],
    components: {
        Modal,
        ValidationObserver,
        ValidationProvider,
        [Select.name]: Select,
        [Option.name]: Option,
    },    
    computed: {
        show: {
            get() {
                return this.create_channel;
            },
            set(newVal) {
                this.$emit('update:create_channel', newVal);
            },
        },
    },
    data() {
        return {
            new_channel: {
                channel_name: '',
                // hub_id: '',
            },
        }
    },
    methods:{
        submit(){
            let form = new FormData()
            form.append('name',this.new_channel.channel_name)
            axios.post(services.lookup + 'channel', form, { headers: getHeader() })
            .then(res => {
                this.notifySuccess('<b>Status: '+res.data.message+'</b> - Successfully Created.')
                this.$emit('closeModal', false)
                EventBus.$emit('getAllChannel')
                this.resetFormToNull(this.new_channel)
            })
            .catch(e => {
                this.errorFunction(e)
            })
        },
    }
}
</script>